/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "wolftechAdminApi",
            "endpoint": "https://lr33r9hx1j.execute-api.eu-west-2.amazonaws.com/home",
            "region": "eu-west-2"
        },
        {
            "name": "wolftechContactApi-home",
            "endpoint": "https://o0f9oz9qq6.execute-api.eu-west-2.amazonaws.com/home",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:dc5dd5a6-29e5-45c4-922e-8ce4efdeaaa1",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_eRyopompw",
    "aws_user_pools_web_client_id": "217p4p1l6l8vk0tpir68b2o6mo",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "WolfContactTable-home",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
